/**
 * Secondary Insurance Guard
 *
 * Checks if patient has secondary insurance.
 */

import type { GuardWithMetadata } from "./sms.guard";

/**
 * Has Secondary Insurance Guard
 *
 * Checks if the patient answered "Yes" to having secondary insurance.
 */
export const hasSecondaryInsurance: GuardWithMetadata = {
  // biome-ignore lint/suspicious/noExplicitAny: XState guard params are complex
  impl: ({ context, event }: { context: any; event: any }) => {
    // Check event.data first (guards run before actions)
    if (event.data && typeof event.data.hasSecondaryInsurance === "boolean") {
      return event.data.hasSecondaryInsurance === true;
    }

    // Fallback to context (for state restoration)
    return context.hasSecondaryInsurance === true;
  },
  metadata: {
    displayName: "hasSecondaryInsurance",
    description: "Patient has secondary insurance",
    requiresContext: ["hasSecondaryInsurance"],
    category: "context",
  },
};
